import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DateRange } from "react-day-picker";

export interface InvoiceState {
  invoiceData: any | null | undefined | any[];
  invoicePriorityData: any | null | undefined | any[];
  invoiceEscalatedData: any | null | undefined | any[];
  invoiceApprovalList: any | null | undefined | any[];
  invoiceApprovalPriorityList: any | null | undefined | any[];
  invoiceApprovalEscalatedList: any | null | undefined | any[];
  invoiceDetails: any | null | undefined | any[];
  InvoiceFilters: {
    division: any[] | undefined;
    company: any[] | undefined;
    status: any[] | undefined;
    stockist: any[] | undefined;
    dateRange: DateRange | undefined;
    assignee: any[] | undefined;
    city: any[] | undefined;
    district: any[] | undefined;
    state: any[] | undefined;
    fuidNo: any[] | undefined;
    sorting: any[] | undefined;
    textract: any[] | undefined; //textract filter
    dateType: any[] | undefined;
    enteredBy: any[] | undefined;
    approvedBy: any[] | undefined;
    //M10-11637
    fromTime: any[] | undefined;
    toTime: any[] | undefined;
    //M10-11637
  };
  InvoiceFiltersData: {
    division: any[] | undefined;
    company: any[] | undefined;
    status: any[] | undefined;
    stockist: any[] | undefined;
    dateRange: any[] | undefined;
    assignee: any[] | undefined;
    city: any[] | undefined;
    district: any[] | undefined;
    state: any[] | undefined;
    fuidNo: any[] | undefined;
  };
  InvoiceApprovalFilters: {
    division: any[] | undefined;
    company: any[] | undefined;
    status: any[] | undefined;
    stockist: any[] | undefined;
    dateRange: DateRange | undefined;
    assignee: any[] | undefined;
    city: any[] | undefined;
    district: any[] | undefined;
    state: any[] | undefined;
    fuidNo: any[] | undefined;
    sorting: any[] | undefined;
    textract: any[] | undefined;  //textract filter
    dateType: any[] | undefined;
    enteredBy: any[] | undefined;
    approvedBy: any[] | undefined;
  };
  InvoiceApprovalFiltersData: {
    division: any[] | undefined;
    company: any[] | undefined;
    status: any[] | undefined;
    stockist: any[] | undefined;
    dateRange: any[] | undefined;
    assignee: any[] | undefined;
    city: any[] | undefined;
    district: any[] | undefined;
    state: any[] | undefined;
    fuidNo: any[] | undefined;
  };
  EInvoiceFilters: {
    division: any[] | undefined;
    company: any[] | undefined;
    status: any[] | undefined;
    stockist: any[] | undefined;
    dateRange: DateRange | undefined;
    assignee: any[] | undefined;
    city: any[] | undefined;
    district: any[] | undefined;
    state: any[] | undefined;
    fuidNo: any[] | undefined;
  };
  EInvoiceFiltersData: {
    division: any[] | undefined;
    company: any[] | undefined;
    status: any[] | undefined;
    stockist: any[] | undefined;
    dateRange: any[] | undefined;
    assignee: any[] | undefined;
    city: any[] | undefined;
    district: any[] | undefined;
    state: any[] | undefined;
    fuidNo: any[] | undefined;
  };
  isResetFilter: boolean;
  invoiceApprovalData: any | null | undefined | any[];
  einvoicesData: any | null | undefined | any[];
  selectedEInvoice: any | null | undefined | any[];
  selectedInvoices: any | null | undefined | any[];
  invoicesTextractData: any | null | undefined | any[];
  invoiceMappingOrderedProducts: any | null | undefined | any[];
  invoiceMappingOrderData: any | null | undefined | any[];
  invoiceAnalysisData: {
    entry: {
      "All Invoices": number;
      "Priority Tasks": number;
      "Escalated": number;
    };
    approval: {
      "All Invoices": number;
      "Priority Tasks": number;
      "Escalated": number;
    };
  };
  invoiceMappingOriginalDescriptions: any;
  invoiceStockistTextractData: any;
  invoiceEntryTab: number;  //M10-11601
  invoiceApprovalTab: number;  //M10-11601
}

const invoiceSlice = createSlice({
  name: "invoice",
  initialState: {
    invoiceData: [],
    invoiceDetails: [],
    invoicePriorityData: [],
    invoiceEscalatedData: [],
    invoiceApprovalList: [],
    invoiceApprovalPriorityList: [],
    invoiceApprovalEscalatedList: [],
    InvoiceFilters: {
      division: [],
      company: [],
      status: [],
      stockist: [],
      dateRange: {
        from: undefined,
        to: undefined,
      },
      assignee: [],
      city: [],
      district: [],
      state: [],
      fuidNo: [],
      sorting: [],
      textract: [],  //textract filter
      dateType: [],
      enteredBy: [],
      approvedBy: [],
      //M10-11637
      fromTime:  undefined,
      toTime: undefined
      //M10-11637
    },
    InvoiceFiltersData: {
      division: [],
      company: [],
      status: [],
      stockist: [],
      dateRange: [],
      assignee: [],
      city: [],
      district: [],
      state: [],
      fuidNo: [],
    },
    InvoiceApprovalFilters: {
      division: [],
      company: [],
      status: [],
      stockist: [],
      dateRange: {
        from: undefined,
        to: undefined,
      },
      assignee: [],
      city: [],
      district: [],
      state: [],
      fuidNo: [],
      sorting: [],
      textract: [],  //textract filter
      dateType: [],
      enteredBy: [],
      approvedBy: [],
    },
    InvoiceApprovalFiltersData: {
      division: [],
      company: [],
      status: [],
      stockist: [],
      dateRange: [],
      assignee: [],
      city: [],
      district: [],
      state: [],
      fuidNo: [],
    },
    EInvoiceFilters: {
      division: [],
      company: [],
      status: [],
      stockist: [],
      dateRange: {
        from: undefined,
        to: undefined,
      },
      assignee: [],
      city: [],
      district: [],
      state: [],
      fuidNo: [],
    },
    EInvoiceFiltersData: {
      division: [],
      company: [],
      status: [],
      stockist: [],
      dateRange: [],
      assignee: [],
      city: [],
      district: [],
      state: [],
      fuidNo: [],
    },

    isResetFilter: false,
    invoiceApprovalData: [],
    einvoicesData: [],
    selectedEInvoice: [],
    selectedInvoices: [],
    invoicesTextractData: [],
    invoiceMappingOrderedProducts: [],
    invoiceMappingOrderData: [],
    invoiceAnalysisData: {
      entry: {
        "All Invoices": 0,
        "Priority Tasks": 0,
        "Escalated": 0,
      },
      approval: {
        "All Invoices": 0,
        "Priority Tasks": 0,
        "Escalated": 0,
      },
    },
    invoiceMappingOriginalDescriptions: [],
    invoiceStockistTextractData: [],
    //M10-11601
    invoiceEntryTab: 0,
    invoiceApprovalTab: 0
    //M10-11601
  } as InvoiceState,
  reducers: {
    setInvoiceData(state, action: PayloadAction<any[] | null | undefined>): void {
      state.invoiceData = action.payload;
    },
    setInvoicePriorityData(state, action: PayloadAction<any[] | null | undefined>): void {
      state.invoicePriorityData = action.payload;
    },
    setInvoiceEscalatedData(state, action: PayloadAction<any[] | null | undefined>): void {
      state.invoiceEscalatedData = action.payload;
    },
    setInvoiceApprovalList(state, action: PayloadAction<any[] | null | undefined>): void {
      state.invoiceApprovalList = action.payload;
    },
    setInvoiceApprovalPriorityList(state, action: PayloadAction<any[] | null | undefined>): void {
      state.invoiceApprovalPriorityList = action.payload;
    },
    setInvoiceApprovalEscaltedList(state, action: PayloadAction<any[] | null | undefined>): void {
      state.invoiceApprovalEscalatedList = action.payload;
    },
    setInvoiceDetails(state, action: PayloadAction<any[] | null | undefined>): void {
      state.invoiceDetails = action.payload;
    },
    setInvoiceFilters(state, action: PayloadAction<{ key: keyof typeof state.InvoiceFilters; value: any[] | DateRange | undefined |string}>) {  //M10-11637
      const { key, value } = action.payload;
      if (key === "dateRange" && value) {
        state.InvoiceFilters[key] = value as DateRange; // Convert back to Date
      } else {
        state.InvoiceFilters[key] = value as any;
      }
    },

    setInvoiceFiltersData(state, action: PayloadAction<{ key: keyof typeof state.InvoiceFiltersData; value: any[] | undefined }>) {
      const { key, value } = action.payload;
      state.InvoiceFiltersData[key] = value;
    },
    setInvoiceApprovalFilters(
      state,
      action: PayloadAction<{ key: keyof typeof state.InvoiceApprovalFilters; value: any[] | DateRange | undefined }>
    ) {
      const { key, value } = action.payload;
      if (key === "dateRange" && value) {
        state.InvoiceApprovalFilters[key] = value as DateRange; // Convert back to Date
      } else {
        state.InvoiceApprovalFilters[key] = value as any;
      }
    },

    setInvoiceApprovalFiltersData(state, action: PayloadAction<{ key: keyof typeof state.InvoiceApprovalFiltersData; value: any[] | undefined }>) {
      const { key, value } = action.payload;
      state.InvoiceApprovalFiltersData[key] = value;
    },
    setEInvoiceFilters(state, action: PayloadAction<{ key: keyof typeof state.EInvoiceFilters; value: any[] | DateRange | undefined }>) {
      const { key, value } = action.payload;
      if (key === "dateRange" && value) {
        state.EInvoiceFilters[key] = value as DateRange; // Convert back to Date
      } else {
        state.EInvoiceFilters[key] = value as any;
      }
    },

    setEInvoiceFiltersData(state, action: PayloadAction<{ key: keyof typeof state.EInvoiceFiltersData; value: any[] | undefined }>) {
      const { key, value } = action.payload;
      state.EInvoiceFiltersData[key] = value;
    },
    setIsResetFilter(state, action: PayloadAction<boolean>) {
      state.isResetFilter = action.payload;
    },
    setInvoiceApprovalData(state, action: PayloadAction<any[] | null | undefined>): void {
      state.invoiceApprovalData = action.payload;
    },
    setEinvoicesData(state, action: PayloadAction<any[] | null | undefined>): void {
      state.einvoicesData = action.payload;
    },
    setSelectedEInvoice(state, action: PayloadAction<any[] | null | undefined>): void {
      state.selectedEInvoice = action.payload;
    },
    toggleSelectedInvoice(state, action: PayloadAction<{ key: string; fuid_no: string; invoice_assignment_id: number }>): void {
      const { key, fuid_no, invoice_assignment_id } = action.payload;

      const exists = state.selectedInvoices.some((invoice: any) => invoice.key === key && invoice.fuid_no === fuid_no);

      if (exists) {
        state.selectedInvoices = state.selectedInvoices.filter((invoice: any) => !(invoice.key === key && invoice.fuid_no === fuid_no));
      } else {
        state.selectedInvoices.push({ key, fuid_no, invoice_assignment_id });
      }
    },
    clearSelectedInvoices(state) {
      state.selectedInvoices = [];
    },
    setInvoicesTextractData(state, action: PayloadAction<any[] | null | undefined>): void {
      state.invoicesTextractData = action.payload;
    },
    setInvoiceMappingOrderedProducts(state, action: PayloadAction<any[] | null | undefined>): void {
      state.invoiceMappingOrderedProducts = action.payload;
    },
    setInvoiceMappingOrderData(state, action: PayloadAction<any[] | null | undefined>): void {
      state.invoiceMappingOrderData = action.payload;
    },
    setInvoiceAnalysisData(state, action: PayloadAction<{
      entry: {
        "All Invoices": number;
        "Priority Tasks": number;
        "Escalated": number;
      };
      approval: {
        "All Invoices": number;
        "Priority Tasks": number;
        "Escalated": number;
      };
    }>): void {
      state.invoiceAnalysisData = action.payload;
    },
    setInvoiceMappingOriginalDescriptions(state, action: PayloadAction<any[] | null | undefined>): void {
      state.invoiceMappingOriginalDescriptions = action.payload;
    },
    setInvoicesStockistTextractData(state, action: PayloadAction<any[] | null | undefined>): void {
      state.invoiceStockistTextractData = action.payload;
    },
    //M10-11601
    setInvoiceEntryTab(state, action: PayloadAction<number>): void {
      state.invoiceEntryTab = action.payload;
    },
    setInvoiceApprovalTab(state, action: PayloadAction<number>): void {
      state.invoiceApprovalTab = action.payload;
    },
    //M10-11601
  },
});

export const invoiceActions = invoiceSlice.actions;
export { invoiceSlice };
